import { useCallback, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { Condition } from "../../../core/api/requests/store/search/types";
import { CampaignManager } from "../../../core/storage/CampaignManager";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { Campaign } from "../../../ducks/campaign";
import { StoreSearchType } from "../../../ducks/store";
import { useNavigation } from "../../../hooks/useNavigation";
import { useStore } from "../../../hooks/useStore";
import { getCurrentDateUTC } from "../../../utils/date";

export const useShopSearch = () => {
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { selectedDate } = state ?? {};
  const campaign = LocalStorageManager.Instance.getObject<Campaign>(
    AppConfig.Instance.LocalStorageKey["campaign"],
  );

  // 在庫販売モードかどうか
  const isStockItemMode = CampaignManager.isStockItemMode();

  const [pickupDate, setPickupDate] = useState<string>(
    selectedDate ?? campaign?.minSaleStartDate ?? getCurrentDateUTC(),
  );

  const { type, query, query1, query2 } = useParams<{
    type: string;
    query?: string;
    query1?: string;
    query2?: string;
  }>();

  const queryText = useMemo(() => {
    if (
      type === StoreSearchType.Text.valueOf() ||
      type === StoreSearchType.StoreCode.valueOf()
    ) {
      return query;
    }

    if (type === StoreSearchType.Address.valueOf()) {
      if (query) return query;

      if (query1 && query2) return `${query1}${query2}`;
    }

    return "";
  }, [type, query, query1, query2]);

  const conditions: Condition[] = useMemo(() => {
    if (
      query &&
      (type === StoreSearchType.Text.valueOf() ||
        type === StoreSearchType.MyStore.valueOf())
    ) {
      return [
        {
          name: "店舗名・住所名",
          operator: "like",
          value: query,
        },
      ];
    }

    if (query && type === StoreSearchType.StoreCode.valueOf()) {
      return [
        {
          name: "店舗コード",
          operator: "equal",
          value: query,
        },
      ];
    }

    if (query && type === StoreSearchType.Address.valueOf()) {
      return [
        {
          name: "都道府県",
          operator: "equal",
          value: query,
        },
      ];
    }

    if (query1 && query2 && type === StoreSearchType.Address.valueOf()) {
      return [
        {
          name: "都道府県",
          operator: "equal",
          value: query1,
        },
        {
          name: "市区町村",
          operator: "equal",
          value: query2,
        },
      ];
    }

    return [];
  }, [type, query, query1, query2]);

  const { stores, setFavoriteStore } = useStore(conditions);

  const handleSelectShop = useCallback(
    (storeCode: string, pickupDate: string) => {
      navigateToPage(
        PageRoutes.MENU_LIST.replace(":storeCode", storeCode).replace(
          ":date",
          pickupDate,
        ),
      );
    },
    [],
  );

  return {
    type,
    queryText,
    stores,
    pickupDate,
    selectedDate,
    setPickupDate,
    setFavoriteStore,
    handleSelectShop,
    campaign,
    isStockItemMode,
  };
};
